// Graceful "session expired" screen. Shown instead of an abrupt redirect when
// a request comes back 401 mid-session (token expired, or a long backend
// downtime cleared the active session server-side). Lets the agent re-sign-in
// deliberately rather than being bounced without explanation.
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export default function SessionExpired() {
  const nav = useNavigate();
  return (
    <div
      data-testid="session-expired-screen"
      className="min-h-screen flex items-center justify-center bg-background text-foreground px-6"
    >
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-amber-500/10 text-amber-600 dark:text-amber-400">
          <ShieldAlert className="h-8 w-8" />
        </div>
        <h1 className="text-2xl font-semibold tracking-tight">Your session expired</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          You were signed out for security — this can happen after a long period
          of inactivity or a server maintenance window. Please sign in again to
          resume your shift. Any active call state is restored automatically.
        </p>
        <Button
          data-testid="session-expired-signin-btn"
          className="mt-8 h-11 w-full rounded-full bg-secondary text-secondary-foreground hover:bg-secondary/90"
          onClick={() => nav("/login", { replace: true })}
        >
          Sign in again
        </Button>
      </div>
    </div>
  );
}
